import React from 'react';
import { SkeletonPanel, SkeletonText, SkeletonPage, SkeletonBox } from '../../components';



export const SellerOrderLoader: React.FC = () => {
  return (
    <SkeletonPage
      title={true}
      subtitle={true}
      actions={true}
      breadcrumbs={true}
      loading={true}
    >
      <div className="flex flex-wrap items-start justify-center gap-5">
        <div className="min-w-[51%] flex-[2_2_30rem] space-y-5">

          <SkeletonPanel>
            <SkeletonPanel.Section>
            <SkeletonText lines={4}  />

            </SkeletonPanel.Section>
          </SkeletonPanel>
       <SkeletonPanel>
            <SkeletonPanel.Section title={true}>
            <SkeletonText lines={3}  />

            </SkeletonPanel.Section>
            <SkeletonPanel.Section title={true}>
            <SkeletonText lines={3}  />

            </SkeletonPanel.Section>
          </SkeletonPanel>
        </div>
        <div className="min-w-0 flex-[1_1_15rem] space-y-5">
          <SkeletonPanel>
            <SkeletonPanel.Section title={true}>
              <SkeletonText lines={3} />
              <div className="flex justify-end mt-6 space-x-4">
                <SkeletonBox height={25} width={100} />
              </div>
            </SkeletonPanel.Section>
          </SkeletonPanel>

        </div>
      </div>
    </SkeletonPage>
  );
};
